import { isMissingFolderMessage } from '@utils-global';
import { AxiosError, isAxiosError } from 'axios';

/**
 * Pulls the diagnostics Graph puts in a failed response so they can travel along
 * as an error context instead of being re-extracted at every catch site.
 *
 * The request ids come from the response headers rather than the body. They are
 * the only handle Microsoft support can use to look a failed call up on their
 * side, so they have to travel with the error too.
 * https://learn.microsoft.com/graph/errors
 */
export const getGraphErrorContext = (error: unknown, destinationFolderId?: string) => {
  if (!isAxiosError(error)) {
    return {};
  }

  const { response } = error as AxiosError<{ error?: { code?: string; message?: string } }>;
  const graphErrorMessage = response?.data?.error?.message;

  return {
    responseStatus: response?.status,
    graphErrorCode: response?.data?.error?.code,
    graphErrorMessage,
    // Decided here, where the destination we sent is still in scope, so nothing downstream has
    // to re-read the server text to learn the mailbox is missing the folder we asked for.
    ...(isMissingFolderMessage(graphErrorMessage, destinationFolderId) && { missingFolder: true }),
    graphRequestId: response?.headers?.['request-id'],
    graphClientRequestId: response?.headers?.['client-request-id'],
  };
};
